/**
 * Google Analytics 4 (GA4) Tracking Utility
 */

export const initGA = (measurementId) => {
  if (!measurementId) {
    console.warn("GA4 Measurement ID not configured. Analytics tracking disabled.");
    return;
  }

  // Check if script is already added
  if (document.getElementById("google-tag-manager")) return;

  const script = document.createElement("script");
  script.id = "google-tag-manager";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    send_page_view: false, // Handle page views manually via router
  });
};

export const trackPageview = (path) => {
  if (window.gtag) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
};

export const trackEvent = (action, category, label, value) => {
  if (window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};
